import React, { useEffect, useRef, useState } from 'react';
import Hls from 'hls.js';
import Header from '../components/Header';
import { Eye, Star, Heart } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import Card_3 from '../components/Card_3';
import { useAddToFav , checkIfFav  } from '../Functions';
import MobileNav from '../components/MobileNav';


export default function Single() {

    const AddToFav = useAddToFav();




    const location = useLocation();
    const { video, channel } = location.state || {};

    const videoRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState(null);

    const [isFav, setIsFav] = useState(false);

    function convertToMinutes(numb) {
        const totalSeconds = Math.floor(numb * 0.0166667 * 60); // convert to seconds
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        // Add leading zeros
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    }



    useEffect(() => {
        if (!video) return;

        setLoading(true);
        fetch(`https://apiv2.mobileartsme.com/laki_geturl?videoId=${video.ID}`)
            .then(resp => resp.json())
            .then(data => {
                setUrl(data.result);
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching video URL:", err);
                setLoading(false);
            });
    }, [video]);

    useEffect(() => {
        let hls;
    
        if (url && videoRef.current) {
            if (Hls.isSupported()) {
                hls = new Hls();
                hls.loadSource(url);
                hls.attachMedia(videoRef.current);
                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    videoRef.current?.play().catch((err) => {
                        console.warn('Autoplay failed:', err);
                    });
                });
            } else if (videoRef.current.canPlayType('application/vnd.apple.mpegurl')) {
                videoRef.current.src = url;
                videoRef.current.play().catch((err) => {
                    console.warn('Autoplay fallback failed:', err);
                });
            }
        }
    
        // 🧼 Cleanup when unmounted
        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [url]);
    


    useEffect(() => {
        window.scrollTo(0, 0);
        if (video?.Thumbnail) {
            checkIfFav(video.ID, setIsFav);
        }
    }, [video]);


    return (
        <>
            <Header />

            <section className='container' style={{ marginBottom:'7rem' }}>
                <div className='row'>
                    <div className='col-lg-8'>
                        <h3 className='text-light'>Now Watching</h3>
                        <div className='mb-4'>

                            {loading || !url ? (
                                <div className='position-relative'>
                                    <img
                                        src={video?.Thumbnail}
                                        alt="Thumbnail"
                                        width="100%"
                                        style={{
                                            aspectRatio: '2/1',
                                            objectFit: 'cover',
                                            filter: 'blur(1px) brightness(0.7)'
                                        }}
                                    />
                                    <div className="position-absolute top-50 start-50 translate-middle text-light text-center">
                                        <div className="spinner-border text-light mb-2" role="status" />
                                        <div>Loading video...</div>
                                    </div>
                                </div>
                            ) : (
                                <video
                                    ref={videoRef}
                                    controls
                                    muted // 🔑 THIS IS THE FIX

                                    autoPlay // <- optional, usually not needed with HLS
                                    width="100%"
                                    style={{
                                        aspectRatio: '2/1',
                                        objectFit: 'cover',
                                        background: 'black'
                                    }}
                                />
                            )}

                            <h4 className='text-light mt-3 d-flex flex-row align-items-center justify-content-between'>
                                {video?.Title}
                                <span className='time'>{convertToMinutes(video.Duration)}</span>
                            </h4>
                            <div className='card-info d-flex flex-row justify-content-between align-items-center'>
                                <div className='d-flex flex-row gap-3' >
                                    <p className='text-light p-0 m-0'>
                                        <Eye size={15} color='white' /> {video?.PlayCount}
                                    </p>
                                    <p className='text-light p-0 m-0'>
                                        <Star size={15} fill='#d4a014d6' strokeWidth={0} /> {video?.avrate}
                                    </p>
                                </div>
                                <button className='addToFav' style={{ position: 'relative' }} onClick={()=>AddToFav(video , setIsFav)}>
                                    <Heart color='var(--main-pink)'  size={20}  fill={isFav ? 'var(--main-pink)' : 'none'} />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-4'>
                        <h3 className='text-light'>Similar Videos</h3>
                        <div className='scrollableDiv'>
                            {channel?.map((vid, index) => (
                                <Card_3 key={index} video={vid} channel={channel} />
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <MobileNav/>
        </>
    );
}
